<template>
  <div class="c-bookmarks">
    <div class="c-bookmarks-group">
      <the-button
        v-for="(bookmark, i) in bookmarks"
        :key="i" :cssClass="'c-bookmarks-group__button'"
        @click.native="updateTimecode(bookmark.fields.text.text)"
      >
        {{ i + 1 }}. {{ bookmark.fields.title.text }}
      </the-button>
    </div>

    <div class="c-bookmarks-show-text">
      <the-button
        :cssClass="'c-bookmarks-show-text__button'"
        @click.native="openModal(content[1].fields.content.content)"
      >
        Vis teksten
      </the-button>
    </div>
  </div>
</template>

<script>
import TheButton from '@/components/TheButton.vue';
import VModal from 'vue-js-modal';

export default {
  name: 'TheBookmarks',

  props: {
    content: Array,
  },

  computed: {
    bookmarks() {
      return this.content.filter((c, i) => i > 1);
    },
  },

  components: {
    TheButton,
    VModal,
  },

  methods: {
    openModal(content) {
      this.$modal.show('bookmarks', { content });
    },

    updateTimecode(time) {
      this.$emit('update-timecode', time);
    },
  },
};
</script>

<style>
.c-bookmarks-group {
  margin: 8px auto;
  text-align: center;
}

.c-bookmarks-group__button {
  background: #eee;
  display: inline-block;
  padding: 5px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.2px;
  margin-right: 8px;
  margin-top: 20px;
}

.c-bookmarks-show-text {
  text-align: center;
  margin-top: 30px;
  border-top: #fff solid 1px;
  padding-top: 20px;
  margin-bottom: 10px;
}

.c-bookmarks-show-text__button {
  background: #2e2d84;
  color: #fff;
  border: #fff solid 2px;
  border-radius: 8px;
  font-weight: 600;
  padding: 5px 15px;
}

@media (min-width: 500px) {
  .c-bookmarks {
    display: flex;
    align-items: stretch;
  }

  .c-bookmarks-group {
    width: 70%;
    border-right: #eee solid 1px;
    text-align: left;
  }

  .c-bookmarks-group__button {
    margin-top: 10px;
  }

  .c-bookmarks-show-text {
    margin: 0;
    border-top: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 30%;
  }
}
</style>
